var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayNow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.82,
    height: 27.76,
    viewBox: "0 0 20.82 27.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-sim-card",
    "data-name": "Icon awesome-sim-card",
    d: "M0,3.47V24.29a3.473,3.473,0,0,0,3.47,3.47H17.35a3.473,3.473,0,0,0,3.47-3.47V6.94L13.88,0H3.47A3.473,3.473,0,0,0,0,3.47ZM12.145,13.88H8.675V10.41h3.47Zm5.205,0H13.88V10.41h1.735a1.733,1.733,0,0,1,1.735,1.735Zm-3.47,6.94h3.47v1.735a1.733,1.733,0,0,1-1.735,1.735H13.88Zm-5.205,0h3.47v3.47H8.675Zm-5.205,0H6.94v3.47H5.205A1.733,1.733,0,0,1,3.47,22.555Zm0-5.205H17.35v3.47H3.47Zm0-3.47A1.733,1.733,0,0,1,5.205,10.41H6.94v3.47H3.47Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayNow);
export default __webpack_public_path__ + "static/media/payNow.27aa2d9580d0fdbf204b5e10785de469.svg";
export { ForwardRef as ReactComponent };